var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-edit_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.75 20a.75.75 0 0 1-.53-.22.78.78 0 0 1-.21-.68l1.29-6.43c.03-.14.1-.28.21-.38L13 .79C13.5.28 14.17 0 14.88 0s1.37.27 1.88.77l2.44 2.44c.51.5.79 1.17.79 1.88s-.27 1.38-.77 1.89l-2.51 2.51-9 9c-.1.1-.24.18-.38.21L.9 19.99S.8 20 .75 20m1.98-6.81-1.02 5.1 5.1-1.02 8.31-8.31-4.08-4.08zm9.37-9.37 4.08 4.08 1.96-1.96c.46-.47.46-1.21 0-1.66l-2.42-2.42c-.23-.23-.53-.35-.84-.35s-.6.12-.82.35l-1.97 1.97z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-edit_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgIcEdit;